module.exports = __webpack_public_path__ + "static/img/icon_map.5cc95a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_map.png
// module id = 7iNd
// module chunks = 1